export default __webpack_public_path__ + "static/media/screwguage.0af76ebe.jpg";